export enum FlinkerProfileStatus {
	Active = 'Active',
	Churning = 'Churning',
	Disabled = 'Disabled',
}
